module.exports = __webpack_public_path__ + "img/thunderstorm-light.e5c65c12.png";